<template>
  <div class="w3-container w3-responsive">

    <!-- 内容区域 -->
    <div class="w3-card" style="max-width: 100%; margin: 0">
      <header class="w3-container w3-green">
        <h2>账号信息</h2>
      </header>
      <!-- 加载状态 -->
      <div v-if="loading" class="w3-panel w3-green w3-display-container">
        <span class="w3-button w3-large w3-display-topright" @click="loading = false">×</span>
        <p>loading...</p>
      </div>

      <!-- 错误提示 -->
      <div v-if="error" class="w3-panel w3-red">
        <p>{{ error }}</p>
      </div>

      <div class="w3-container w3-padding-16 w3-text-grey">
        <div class="w3-flex" style="justify-content: space-between">
          <h6>登录名:</h6>
          <h6>{{ agentName }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6>用户数：</h6>
          <h6>{{ $filters.formatNumber(userCount) }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6 @click="goToHelp1();">佣金比例(?):</h6>
          <h6>{{ $filters.formatNumber(ratio * 100) }}%</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6 @click="toToTransfer();">佣金(转出):</h6>
          <h6>{{ $filters.formatNumber(coinBalance) }}</h6>
        </div>
        <div class="w3-flex" style="justify-content: space-between">
          <h6 @click="goToHelp2">代理链接(?):</h6>
          <h6>{{ agentURL }}</h6>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      agentName: '',
      ratio: 0,
      coinBalance: 0,
      userCount: 0,
      agentURL: '',
      loading: false,
      error: ''
    };
  },
  mounted() {
    const query = this.$route.query;
    if (query.u && query.p) {
      sessionStorage.setItem('agentName', query.u);
      sessionStorage.setItem('agentPass', query.p);
    }
    this.agentName = sessionStorage.getItem('agentName');
    this.agentPass = sessionStorage.getItem('agentPass');
    if (this.agentName && this.agentPass) {
      this.fetchData();
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = '';
      try {
        const response = await axios.get(`${this.$apiUrl}/getAgentInfo?agentname=${this.agentName}&t=${this.agentPass}`);
        if (response.data.code == 200) {
          this.agentName = response.data.result.agentName;
          this.ratio = response.data.result.ratio;
          this.coinBalance = response.data.result.coinBalance;
          this.userCount = response.data.result.userCount;
          this.agentURL = response.data.result.agentURL
        } else if (response.data.code == 300) {
          this.error = response.data.result;
        } else if (response.data.code == 400) {
          this.$router.push('/login?err=1');
        } else if (response.data.code == 500) {
          this.error = response.data.result;
        }
      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    goToHelp1() {
      this.$router.push('/commissionhelp');
    },
    goToHelp2() {
      this.$router.push('/agentlinkhelp');
    },
    toToTransfer() {
      this.$router.push('/transferOut');
    }
  }
};
</script>

<style scoped>
.w3-image {
  display: block;
  margin: 0 auto;
  padding: 20px;
  background: white;
  border: 1px solid #ddd;
}
</style>